module.exports = __webpack_public_path__ + "img/fantasy.12cf3c15.svg";